
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule } from '@/store'

import EmploymentDto from '../../../types/dto/employmentDto'

	@Component({
	  name: 'EmploymentStatus'
	})
export default class EmploymentStatus extends Vue implements IAppForm {
		// #region Props
		@Prop() employment!: EmploymentDto;
		@Prop() wizardIndex!: number;
		@Prop({ default: false }) compact!: boolean;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		// #endregion

		// #region Data

		accordionOpen = false;
		showError = false;
		showOccupationError = false;
		showNameError = false;
		showTownError = false;

		// #endregion

		// #region Methods

		val = -1;

		submit () {
		  if (!this.validate()) { return }
		  this.$emit('change', this.val)
		  this.$emit('submit', this.wizardIndex)
		}

		validate () {
		  this.showError = false

		  if (!this.employment.employmentStatusLookup.id || this.employment.employmentStatusLookup.id <= 0) {
		    this.showError = true
		    return false
		  }

		  return true
		}

		setValue (val: number) {
		  this.showError = false
		  this.employment.employmentStatusLookup.id = val

		  if (val !== 0) {
		    setTimeout(() => { this.submit() }, 500)
		  }
		}

		// #endregion

		// #region Computed

		get editingEmploymentIndex () {
		  return ApplicationModule.editingEmploymentIndex ?? -1
		}

		get shortArray () {
		  return [
		    { label: 'Full-time', value: 9 },
		    { label: 'Part-time', value: 11 },
		    { label: 'Self-employed', value: 10 },
		    { label: 'Other', value: 0 }
		  ]
		}

		get otherArray () {
		  return [
		    { label: 'Disability', value: 12 },
		    { label: 'Retired', value: 13 },
		    { label: 'Sub-contractor', value: 14 },
		    { label: 'Agency worker', value: 15 },
		    { label: 'Homemaker', value: 16 },
		    { label: 'Not employed', value: 17 },
		    { label: 'Armed forces', value: 18 },
		    { label: 'Student', value: 19 },
		    { label: 'Family carer', value: 21 }
		  ]
		}

		get fullArray () {
		  return [
		    { label: 'Full-time', value: 9 },
		    { label: 'Part-time', value: 11 },
		    { label: 'Self-employed', value: 10 },
		    { label: 'Disability', value: 12 },
		    { label: 'Retired', value: 13 },
		    { label: 'Sub-contractor', value: 14 },
		    { label: 'Agency worker', value: 15 },
		    { label: 'Homemaker', value: 16 },
		    { label: 'Not employed', value: 17 },
		    { label: 'Armed forces', value: 18 },
		    { label: 'Student', value: 19 },
		    { label: 'Family carer', value: 21 }
		  ]
		}
		// #endregion

		// #region Watches

		@Watch('editingEmploymentIndex')
		changeEmployment () {
		  this.employment = ApplicationModule.editingEmployment
		}

		@Watch('employment.employmentStatusLookup.id', { deep: true, immediate: true })
		async clearError () {
		  setTimeout(() => {
		    this.accordionOpen = !!(this.employment.employmentStatusLookup.id !== undefined && this.employment.employmentStatusLookup.id !== null && this.employment.employmentStatusLookup.id > -1 &&
					this.employment.employmentStatusLookup.id !== 9 &&
					this.employment.employmentStatusLookup.id !== 11 &&
					this.employment.employmentStatusLookup.id !== 10)
		  })
		}

  // #endregion
}
